export default __webpack_public_path__ + "static/media/sql-icon.7dc4ae06.svg";